export default __webpack_public_path__ + "static/media/06 3D (2-3).f9b7ae29.jpg";